import React, { Component } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import {
  func, string, arrayOf, bool
} from 'prop-types';
import { surveySchemaMetadataType } from '../../../../constants/types';
import { getLocalizedText } from '../../../../util';
import { withLang, langType } from '../../../../i18n';

import styles from './schemaPartDragDrop.module.css';

class SchemaPartDragDrop extends Component {
  constructor(props) {
    super(props);

    this.onDragEnd = this.onDragEnd.bind(this);
    this.renderSchemaPart = this.renderSchemaPart.bind(this);
  }

  onDragEnd(draggedItem) {
    const { updateSchemaParts, schemaParts } = this.props;

    if (!draggedItem.destination) {
      return;
    }

    const reorderedSchemaParts = [...schemaParts];
    const [removedItem] = reorderedSchemaParts.splice(draggedItem.source.index, 1);
    const destinationIndex = draggedItem.destination.index < 0 ? 0 : draggedItem.destination.index;
    reorderedSchemaParts.splice(destinationIndex, 0, removedItem);

    updateSchemaParts(reorderedSchemaParts);
  }

  renderSchemaPart(schemaPart, index) {
    const {
      translate: t,
      currentLanguage,
      lockedFromEditing,
      onRemoveSchemaPart,
      onUpdateSchemaPartVersion
    } = this.props;

    return (
      <Draggable
        key={schemaPart.id}
        draggableId={`${schemaPart.id}`}
        index={index}
        isDragDisabled={lockedFromEditing}
      >
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={provided.draggableProps.style}
            className={
              `${styles.schemaPartItem}
               ${lockedFromEditing && styles.disabledItem}
               ${snapshot.isDragging && styles.itemDragging}`
            }
          >
            {!lockedFromEditing
            && (
              <div className={`icon--drag ${styles.dragIcon}`} />
            )}
            <div className={styles.codeItem}>
              <p>{schemaPart.code}</p>
            </div>
            <div className={styles.version}>
              <p>v. {schemaPart.version}</p>
              { schemaPart.hasLaterVersion
              && (
              <button
                type="button"
                onClick={() => onUpdateSchemaPartVersion(schemaPart.code)}
                className={`icon--arrow-up iconButton ${styles.controlIcon}`}
                title={t('editor.surveySchemaParts.updateSchemaPartVersion')}
              />
              )}
            </div>
            <div className={styles.titleItem}>
              {getLocalizedText(schemaPart.title, currentLanguage, t('surveyParts.titleMissing'))}
            </div>
            <div className={styles.descriptionItem}>
              {getLocalizedText(schemaPart.description, currentLanguage, t('surveyParts.descriptionMissing'))}
            </div>
            {!lockedFromEditing
            && (
            <div className={styles.controlItem}>
              <button
                type="button"
                onClick={() => onRemoveSchemaPart(schemaPart.id)}
                className={`icon--trash ${styles.controlIcon}`}
                title={t('common.remove')}
              />
            </div>
            )}
          </div>
        )}
      </Draggable>
    );
  }

  render() {
    const { schemaParts, lockedFromEditing } = this.props;
    const droppableStyles = { minHeight: `${schemaParts.length * 4}em` };
    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable" isDropDisabled={lockedFromEditing}>
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              className={`${styles.schemaPartList} ${snapshot.isDraggingOver && styles.draggingList}`}
              style={droppableStyles}
              {...provided.droppableProps}
            >
              {schemaParts.map((schemaPart, index) => this.renderSchemaPart(schemaPart, index))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }
}

SchemaPartDragDrop.propTypes = {
  currentLanguage: string.isRequired,
  schemaParts: arrayOf(surveySchemaMetadataType).isRequired,
  onRemoveSchemaPart: func.isRequired,
  updateSchemaParts: func.isRequired,
  lockedFromEditing: bool.isRequired,
  onUpdateSchemaPartVersion: func.isRequired,
  ...langType
};

export default withLang(SchemaPartDragDrop);
